// extracted by mini-css-extract-plugin
export default {"root":"root---n5_z_","content":"content---WySdD","icon":"icon---ZzniI","open":"open---d2JkQ","button":"button---Hhda1"};